// Plausible custom events (https://plausible.io/docs/custom-event-goals), declared in views with data attributes:
//
//   a link with data-analytics-event="Shopping click" data-analytics-props='{"store":"eBay"}' sends its event when
//   clicked (or middle-clicked);
//   an element with data-analytics-pageload-event="Search" (and the same props attribute) sends its event as the page
//   loads.
//
// window.plausible queues calls until the Plausible script (layouts/_plausible_tracking_code) loads. It's only loaded in
// production, so elsewhere events just wait in the queue. Never put search terms or anything personal in props: the
// privacy policy promises they aren't collected.

// The queue: Plausible's script, which is deferred, sends what's in it when it runs. This bundle runs in the <head>
// before that script, so the queue is always there first.
window.plausible = window.plausible || function() { (window.plausible.q = window.plausible.q || []).push(arguments) };

function send(element, name) {
  var props = element.getAttribute('data-analytics-props');
  window.plausible(name, props ? { props: JSON.parse(props) } : undefined);
}

function onLinkClick(e) {
  if (e.type === 'auxclick' && e.button !== 1) { return; }
  var link = e.target.closest && e.target.closest('a[data-analytics-event]');
  if (link) { send(link, link.getAttribute('data-analytics-event')); }
}

document.addEventListener('click', onLinkClick);
document.addEventListener('auxclick', onLinkClick);

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-analytics-pageload-event]').forEach(function(element) {
    send(element, element.getAttribute('data-analytics-pageload-event'));
  });
});
